import moment from "moment";
import ActionColumnComponent from "../../../disaster/components/ActionColumn/ActionColumn";

export const getAllColumns = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({
    viewModal,
    updateModal,
    deleteRecord,
  });

  return {
    "Personal Information": [
      {
        title:"Name",
        dataIndex:"Name",
        key:"name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Birth Date",
        dataIndex:"Birth Date",
        key: "birthDay",
        render: (record) => (record ? moment(record).format("MM/DD/YYYY") : "N/A"),
      },
      {
        title: "Social Security Number",
        dataIndex: "Social Security Number",
        key: "socialsecuritynumber",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Street",
        dataIndex: "Street",
        key: "street",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "City",
        dataIndex: "City",
        key: "city",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "State",
        dataIndex: "State",
        key: "state",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Zip",
        dataIndex: "Zip",
        key: "zip",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Phone Number",
        dataIndex: "Phone Number",
        key: "phoneNumber",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
 
    "Children": [
      {
        title: "Name",
        dataIndex: "Name",
        key: "name",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Birth Date",
        dataIndex: "Birth Date",
        key: "birthday",
        render: (record) => (record ? moment(record).format("MM/DD/YYYY") : "N/A"),
      },
      {
        title: "School",
        dataIndex: "School",
        key: "school",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Special Needs/Requirements",
        dataIndex: "Special Needs/Requirements",
        key: "specialneedsrequiremtnts",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Activities/Schedules",
        dataIndex: "Activities/Schedules",
        key: "activitiesschedules",
        render: (record) => (record ? record : "N/A"),
      },
      {
        title: "Healthcare Provider",
        dataIndex: "Healthcare Provider",
        key: "healthcareprovider",
        render: (record) => (record ? record : "N/A"),
      },
      actionColumn,
    ],
  };
};
